var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSelectIcon = function SvgSelectIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29297 8.41421L0.292969 1.41421L1.70718 0L8.00008 6.29289L14.293 0L15.7072 1.41421L8.70718 8.41421C8.31666 8.80474 7.68349 8.80474 7.29297 8.41421Z",
    fill: "#767676"
  })));
};
export { SvgSelectIcon as ReactComponent };
export default __webpack_public_path__ + "assets/377042e6.svg";